<template>
  <div v-if="visible" :class="`d-flex align-items-center justify-content-center alert ${alertClass} ${{ mobile: isMobile }}`" role="alert">
    <img class="icon-danger align-self-center" src="@/assets/img/icons/information-circle.svg"></img>
    {{ message }} <a @click="openUrl()">{{ link.text }}</a>
  </div>
</template>

<script>
import { EventBus } from "@/main.js";


export default {
  name: 'Topbar',
  props: {
    isMobile: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      type: "info",
      message: "",
      link: {
        text: "",
        url: "",
      },
      serviceTopbar: null,
    };
  },
  computed: {
    alertClass() {
      return {
        'alert-success': this.type === 'success',
        'alert-danger': this.type === 'danger',
        'alert-warning': this.type === 'warning',
        'alert-info': this.type === 'info'
      }[this.type] || 'alert-primary';
    }
  },
  async created() {
    EventBus.$on("showTopbar", data => {
      this.visible = true;
      this.type = data.type;
      this.message = data.message;
      let linkParts = data.link.split('|');
      this.link.text = linkParts[0];
      this.link.url = linkParts[1];
    });
    await this.$store.dispatch("getTopbarMessage").then((topbarData) => {
      if (topbarData.visible && !this.isLegacyPendingDocsTopbar(topbarData)) {
        this.visible = topbarData.visible;
        this.type = topbarData.type;
        this.message = topbarData.message;
        let linkParts = topbarData.link.split('|');
        this.link.text = linkParts[0];
        this.link.url = linkParts[1];
      }
    });
  },
  methods:{
    // VADM-4996: a faixa legada de "documentacao pendente" foi descontinuada.
    // O fluxo atual de KYC vive em Minha Conta > Dados Financeiros. Suprimimos
    // essa faixa especifica no front (o backend ainda a serve via /topbar para
    // sellers com documentacao pendente). Identificada pela acao "Enviar
    // Documentacao" apontando para /minha-conta. A topbar geral (GENERAL_INFORMATION)
    // continua sendo exibida normalmente.
    isLegacyPendingDocsTopbar(topbarData) {
      const link = (topbarData && topbarData.link) || "";
      const [linkText = "", linkUrl = ""] = link.split('|');
      return linkText.trim() === 'Enviar Documentação' && linkUrl.trim() === '/minha-conta';
    },
    openUrl(){
      if (this.$route.path !== this.link.url) {
          this.$router.push(this.link.url);
      }
    }
  }
};
</script>

<style scoped>
a {
  font-weight: 600;
  cursor: pointer;
}
.alert {
  top: 0;
  z-index: 800;
  text-align: center;
  border-radius: 0px;
  gap: 1rem;
}
.alert.mobile {
  margin-left: -17px;
}
</style>